@if (steps?.length) {
  <div class="ap-progress" role="list" [@list]="steps?.length || 0">
    @for (s of steps; track trackById(i, s); let i = $index; let first = $first; let last = $last) {
      <div class="ap-step" role="listitem" [@step]>
        <mat-icon
          class="ap-ico"
          [ngClass]="{
            'ap-ico--done': s.state === 'done',
            'ap-ico--wait': s.state === 'wait',
          }"
        >
          @switch (s?.state) {
            @case ('done') {
              check
            }
            @default {
              hourglass_empty
            }
          }
        </mat-icon>
        <span class="ap-label">{{ s.label }} {{ getSignaturesCountText(s) }}</span>
      </div>
      @if (!last) {
        <div class="ap-connector" aria-hidden="true" [@connector]></div>
      }
    }
  </div>
}
